
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(1006),
  leaderPosX: Number.withConstraint(x => x >= -1 && x <= 10000),
  leaderPosY: Number.withConstraint(x => x >= -1 && x <= 10000),
  newAllianceId: Number.withConstraint(x => x >= -2),
  newAllianceRank: Number.withConstraint(x => x >= -1 && x <= 100),
  oldAllianceId: Number.withConstraint(x => x >= -2),
  oldAllianceRank: Number.withConstraint(x => x >= -1 && x <= 100),
  playerId: Number.withConstraint(x => x >= 0),
  posX: Number.withConstraint(x => x >= -1 && x <= 10000),
  posY: Number.withConstraint(x => x >= -1 && x <= 10000),
  status: Number.withConstraint(x => x >= 0 && x <= 100),
}).And(Partial({
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(1006),
  leaderPosX: Number.withConstraint(x => x >= -1 && x <= 10000),
  leaderPosY: Number.withConstraint(x => x >= -1 && x <= 10000),
  newAllianceId: Number.withConstraint(x => x >= -2),
  newAllianceRank: Number.withConstraint(x => x >= -1 && x <= 100),
  oldAllianceId: Number.withConstraint(x => x >= -2),
  oldAllianceRank: Number.withConstraint(x => x >= -1 && x <= 100),
  playerId: Number.withConstraint(x => x >= 0),
  posX: Number.withConstraint(x => x >= -1 && x <= 10000),
  posY: Number.withConstraint(x => x >= -1 && x <= 10000),
  status: Number.withConstraint(x => x >= 0 && x <= 100),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
}).And(Partial({
  instanceId: Number.withConstraint(x => x >= 0 && x <= 1000),
  networkId: Number.withConstraint(x => x >= 0 && x <= 1000),
  zoneId: Number.withConstraint(x => x >= -1 && x <= 1000),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 1006;
  